<template>
    <div class="reg-navigation">
        <div class="reg-navigation__top container container--full">

            <router-link :to="{name: 'RegistrationSteps', params: {step: currentStep - 1}}" class="reg-navigation__back">
                <icon name="arrow-left" class="reg-navigation__back__icon"></icon>
                <span class="reg-navigation__back__text" v-translate>back</span>
            </router-link>

            <div class="reg-navigation__logo">
                <router-link :to="{ name: 'Discover'}">
                    <img alt="PUMATRAC" src="../assets/trac-logo-black.svg" />
                </router-link>
            </div>

        </div>
        <div class="reg-navigation__bottom container container--full">

            <nav class="reg-navigation__steps">
                <router-link 
                    :to="{name: 'RegistrationSteps', params: {step: stepIndex + 1}}" 
                    class="reg-navigation__step" 
                    :class="[{'is-completed': currentStep > stepIndex + 1}, {'is-current': currentStep === stepIndex + 1}, {'is-available': availableSteps.indexOf(stepIndex + 1) >= 0 && currentStep < stepIndex + 1}]" 
                    v-for="(step, stepIndex) in steps" 
                    :key="stepIndex"
                >
                    <div class="reg-navigation__step__circle">
                        <div class="reg-navigation__step__circle__number">{{ stepIndex + 1 }}</div>
                        <icon name="checkmark" class="reg-navigation__step__circle__checkmark"></icon>
                    </div>
                    <div class="reg-navigation__step__label">{{step.label}}</div>
                </router-link>
            </nav>

        </div>
 
    </div>
</template>

<script>
export default {
    props: {
        currentStep: {
            type: Number,
            default: 2
        },
        availableSteps: {
            type: Array,
            default: () => [1]
        }
    },
    data() {
        return {
            steps: [
                {
                    label: this.$gettext('registration_step_1_login_data'),
                },
                {
                    label: this.$gettext('registration_step_2_details'),
                },
                // {
                //     label: this.$gettext('registration_step_3_goals'),
                // },
                // {
                //     label: this.$gettext('registration_step_4_frequency'),
                // },
            ]
        }
    }
}
</script>

<style lang="scss">
@import "~sass-mq";

.reg-navigation {
    &__top {
        position: relative;
        padding-top: 24px;
        padding-bottom: 24px;
        display: flex;
        justify-content: center;
        @include mq(tablet) {
            padding-bottom: 45px;
        }
        @include mq(tablet-landscape) {
            padding-bottom: 65px;
        }
    }
    &__bottom {
        display: flex;
        justify-content: center;
        border-bottom: 1px solid rgba(#000, 0.1);
    }
   &__back {
       display: flex;
       align-items: center;
       position: absolute;
       left: 0;
       top: 28px;
        left: $page-padding-small;
            font-size: $puma-size-font-sm;
        @include mq(tablet){
            left: $page-padding-big;
        }
        @include mq(tablet-landscape) {
            font-size: $puma-size-font-md;
        }
       &__icon {
           margin-right: 16px;
            @include mq($until: tablet-landscape) {
                width: 16px;
                height: 16px;
                margin-right: 12px;
            }
       }
       &__text {
           font-weight: $font-weight-bold;
           text-transform: uppercase;
       }
   }
   &__steps {
       display: flex;
       align-items: center;
   }
   &__step {
       display: flex;
       align-items: center;
        font-size: $puma-size-font-xs;
        opacity: 0.5;
        margin-right: 20px;
        pointer-events: none;
        position: relative;
        padding: 12px 0;
        @include mq(tablet) {
            margin-right: 40px;
        }
        @include mq(desktop) {
            font-size: $puma-size-font-sm;
            margin-right: 60px;
        }
        &:last-child {
            margin-right: 0;
        }
        &.is-available,
        &.is-completed{
            pointer-events: auto;
        }
        &.is-available,
        &.is-completed,
        &.is-current {
            opacity: 1;
        }
        &.is-current {
            &::after {
                transform: none;
                background-color: $puma-color-black;
            }
        }
        .no-touch &:hover {
            &::after {
                transform: none;
            }
        }
     
         
        &::after {
            content: '';
            transition:  0.2s;
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: $puma-color-neutral-20;
            transform: scaleY(0);
            transform-origin: bottom center;
        }
       &__circle {
           width: 1.7em;
           height: 1.7em;
           border-radius: 24px;
           display: flex;
           align-items: center;
           justify-content: center;
           border: 1px solid $puma-color-black;
           margin-right: 1.15em;
           @include mq($until: tablet) {
               margin-right: 0;
               .is-current & {
                   margin-right: 1em;
               }
           }
           .is-completed & {
               background-color: $puma-color-neutral-20;
               border: none;
           }
           .is-current & {
               border: none;
               background-color: $puma-color-black;
               color: white;
           }
           &__number {
            font-weight: $font-weight-bold;
            .is-completed & {
                display: none;
            }
           }
           &__checkmark {
               display: none;
               .is-completed & {
                display: block;
            }
           }
       }
       &__label {
           text-transform: uppercase;
           @include mq($until: tablet) {
            display: none;
            .is-current & { 
                display: block;
            }
           }
           .is-completed &,
            .is-current & {
            font-weight: $font-weight-bold;
            }
       }
   }

   &__logo {
       display: flex;
        align-items: center;
        height: 100%;
        line-height: 1;

        img {
            height: 35px;

            @include mq($until: tablet) {
                height: 25px;
            }
        }

   }
}
</style>
